import React, { ReactElement } from "react";
import DriverUnsettleOrderList from "../../components/Driver/UnsettleOrder";

import Layout from "../../components/layout";

const DriverUnsettleOrderPage = (): ReactElement => {
  return (
    <Layout>
      <DriverUnsettleOrderList />
    </Layout>
  );
};

export default DriverUnsettleOrderPage;
